export default __webpack_public_path__ + "static/media/essential_card.d0669c3d.png";